import { IconButton, Tooltip } from "@mui/material";
import DashCard from "./DashCard";
import { InfoRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import NoListItems from "../../Custom/NoListItems";
import { useState } from "react";

const getGradeColor = (grade) => {
  if (grade < 65) return "var(--red)";
  if (grade < 80) return "var(--gold)";
  return "var(--green)";
};

const BoostScoresCard = ({ scores }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const handleClick = (name, id) => {
    const encodedName = encodeURIComponent(name);
    navigate(`/${encodedName}/`, {
      state: { examId: id },
    });
  };

  return (
    <DashCard
      title="Boost Your Scores"
      id="boost"
      cornerContent={
        <IconButton
          fontSize="small"
          className="p-0"
          style={{
            opacity: !scores.length ? 0.5 : 1,
          }}
          disabled={!scores.length}
          onClick={() => setOpen(!open)}
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
        >
          <Tooltip
            title="Click the exams below to improve your scores!"
            open={open && scores.length}
          >
            <InfoRounded color="iconGray" />
          </Tooltip>
        </IconButton>
      }
      children={
        !scores.length ? (
          <NoListItems text="No metrics available" />
        ) : (
          <ul className="scores">
            {scores.map((item) => {
              return (
                <li
                  key={`score-${item.exam__name}`}
                  onClick={() => handleClick(item.exam__name, item.exam__id)}
                  role="button"
                >
                  <small className="ellipsis">{item.exam__name}</small>
                  <small style={{ color: getGradeColor(item.last_grade) }}>
                    {Math.round(item.last_grade)}%
                  </small>
                </li>
              );
            })}
          </ul>
        )
      }
    />
  );
};

export default BoostScoresCard;
